// Header "Tools" menu (a <details> dropdown, works without JS): close it on an outside click or Escape.
export function initNavTools() {
    const menus = [...document.querySelectorAll('details.nav-tools')];
    if (!menus.length) return;
    document.addEventListener('click', (e) => {
        for (const d of menus) if (d.open && !d.contains(e.target)) d.open = false;
    });
    // A link inside the menu (e.g. "#briefing", which opens a window on the same page) closes it.
    for (const d of menus) d.querySelector('.nav-tools-menu')?.addEventListener('click', (e) => e.target.closest('a') && (d.open = false));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') for (const d of menus) d.open = false;
    });
}
